<ng-container *transloco="let t">
    <ng-container
        *ngIf="{
            success: successTransits$ | async,
            fail: failTransits$ | async,
            hidden: hiddenTransits$ | async
        } as groups"
    >
        <bazis-toolbar adaptiveMode="wrap">
            <div
                slot="start"
                class="bh-line-elements"
            >
                <ng-container
                    *ngFor="let transit of groups.success"
                    [ngTemplateOutlet]="transitTpl"
                    [ngTemplateOutletContext]="{ transit: transit }"
                ></ng-container>
                <div *ngIf="saveButtonSettings">
                    <bazis-button
                        *ngIf="{
                            canTransit: canTransit$ | async,
                            hasChanges: hasChanges$ | async
                        } as data"
                        [color]="'action'"
                        [fill]="'solid'"
                        [disabled]="!data.canTransit || !data.hasChanges"
                        (click)="save.emit()"
                    >
                        {{ t(saveButtonSettings.titleKey) }}
                    </bazis-button>
                </div>
            </div>
            <div
                slot="end"
                [class.bh-justify-content-end]="mqSrv.inIntervalBreakpoint('xs', 'sm')"
            >
                <ng-container
                    *ngFor="let transit of groups.fail"
                    [ngTemplateOutlet]="transitTpl"
                    [ngTemplateOutletContext]="{ transit: transit }"
                ></ng-container>

                <ng-container
                    *ngFor="let transit of groups.hidden"
                    [ngTemplateOutlet]="transitTpl"
                    [ngTemplateOutletContext]="{ transit: transit }"
                ></ng-container>
            </div>
        </bazis-toolbar>
    </ng-container>
    <ng-template
        #transitTpl
        let-transit="transit"
    >
        <div
            #tooltip
            *ngIf="
                !transit.main.showSignButtonInsteadOfTransit &&
                (!hideRestricted || !transit.main?.restrictsToDisplay?.length)
            "
        >
            <ng-container *ngIf="{ canTransit: canTransit$ | async } as data">
                <bazis-button
                    *ngIf="actionElement === 'button'"
                    [color]="transit.main.snapshot.transit_type === 'success' ? 'action' : 'danger'"
                    [fill]="transit.main.snapshot.transit_type === 'success' ? 'solid' : 'clear'"
                    [disabled]="
                        !(transitMap && transit.main.isAllowed) ||
                        (formService.transiting.$ | async) === true ||
                        (transit.main.snapshot.is_schema_validate ||
                        isSchemaValidateRedefine[transit.main.snapshot.id]
                            ? !data.canTransit
                            : false)
                    "
                    (click)="transitEntity(transit.group)"
                >
                    {{
                        processTransitingTitleKey && (formService.transiting.$ | async) === true
                            ? t(processTransitingTitleKey)
                            : transit.main.snapshot.name
                    }}
                    <span
                        *ngIf="(formService.transiting.$ | async) === true"
                        class="bazis-loader_dots"
                    ></span>
                    <bazis-icon
                        *ngIf="transit.main?.restrictsToDisplay.length > 0"
                        slot="end"
                        [name]="icons.interrogation"
                    ></bazis-icon>
                </bazis-button>

                <bazis-link
                    *ngIf="actionElement === 'link'"
                    size="regular"
                    class="bh-font-medium"
                    [color]="transit.main.snapshot.transit_type === 'success' ? 'action' : 'danger'"
                    [class.bh-events-none]="
                        !(transitMap && transit.main.isAllowed) ||
                        (transit.is_schema_validate ? !data.canTransit : false)
                    "
                    (click)="transitEntity(transit.group)"
                    >{{ transit.main.snapshot.name
                    }}<bazis-icon
                        *ngIf="transit.main?.restrictsToDisplay.length > 0"
                        slot="end"
                        [name]="icons.interrogation"
                    ></bazis-icon>
                </bazis-link>
            </ng-container>

            <bazis-tooltip
                *ngIf="transit.main?.restrictsToDisplay.length > 0"
                [reference]="tooltip"
                [isStatic]="false"
                placement="top"
                class="bh-popper-z-index"
            >
                <ng-container *ngFor="let restrict of transit.main.restrictsToDisplay">
                    {{ restrict.detail }}
                </ng-container>
            </bazis-tooltip>
        </div>
        <ng-container *ngIf="transit.main.showSignButtonInsteadOfTransit">
            <ng-container *ngIf="{ canTransit: canTransit$ | async } as data">
                <bazis-button
                    *ngIf="actionElement === 'button'"
                    [color]="transit.main.snapshot.transit_type === 'success' ? 'action' : 'danger'"
                    [fill]="transit.main.snapshot.transit_type === 'success' ? 'solid' : 'clear'"
                    [disabled]="!data.canTransit"
                    (click)="formService.signEntity(signContext)"
                >
                    {{ t('action.sign') }}
                </bazis-button>

                <bazis-link
                    *ngIf="actionElement === 'link'"
                    [color]="transit.main.snapshot.transit_type === 'success' ? 'action' : 'danger'"
                    [class.bh-events-none]="!data.canTransit"
                    (click)="formService.signEntity(signContext)"
                    >{{ t('action.sign') }}</bazis-link
                >
            </ng-container>
        </ng-container>
    </ng-template>
</ng-container>
